import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-current-day-display',
  templateUrl: './current-day-display.component.html',
  styleUrls: ['./current-day-display.component.css']
})
export class CurrentDayDisplayComponent implements OnInit {
  
  @Input() currentIcon!: string;
  @Input() currentSignName!: string;
  @Input() currentElement!: string;
  @Input() currentQuality!: string;
  @Input() currentGlyph!: string;
  @Input() currentHouse!: string;
  @Input() currentPlanet!: string;
  @Input() currentShortDescription!: string;
  @Input() currentIsPreOrPost!: string;
  @Input() currentColor!: string;

  @Output() seeDifferentMonth: EventEmitter<any> = new EventEmitter();
  @Output() currentMonthIndex: EventEmitter<any> = new EventEmitter();
  @Output() seeDifferentView: EventEmitter<any> = new EventEmitter();
  

  // let [month, date, year] = new Date().toLocaleDateString("en-US").split("/");
  // let [hour, minute, second] = new Date().toLocaleTimeString("en-US").split(/:| /);

  // month = new Date()
  // [month, date, year] = new Date().toLocaleDateString("en-US").split("/");

  // month: Date = new Date(000000000000);
  // month: Date = new Date();
  // month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  
  monthIs : any = {};
  weekdayIs: any = {};
  dayIs: any = {};
  hourIs: any = {};
  minIs: any = {};
  // dateTest: any = {};
  now: any = new Date();
  dateTest: any = this.now.toISOString();
  dateTest2: any = new Date();
  // color: any;


  // var date2 = new Date();

  // // this.dateTest = date2.toISOString();
  // this.dateTest = date2.toISOString();

  constructor() { }

  ngOnInit(): void {
    var monthArrayId = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    var da = new Date();

    var currentMonthIndexId = monthArrayId[da.getMonth()];

    this.currentMonthIndex.emit(currentMonthIndexId);
    // this.colorFormat();

  }
  ngOnChanges(changes: SimpleChanges){
    this.formatDate();
    // this.colorFormat();
  }

  formatDate() {
    var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    var weekday  = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    var d = new Date();
    this.monthIs = month[d.getMonth()];
    this.weekdayIs = weekday[d.getDay()];
    this.dayIs = d.getDate();
    this.hourIs = d.getHours();
    this.minIs = d.getMinutes()
    
    // var date2 = new Date();

    // // this.dateTest = date2.toISOString();
    // this.dateTest = date2.toISOString();
  };

  prevMonth(){
    this.seeDifferentMonth.emit('prev');
  };
  nextMonth(){
    this.seeDifferentMonth.emit('next');
  };
  changeViewMode(){
    //needs config for proper sign
    this.seeDifferentView.emit(this.currentIsPreOrPost);
  }

  // colorFormat(){
  //   // this.backgroundType ={ 'background-color' : 'rgba(' + this.postSignColor + ', 1)'};

  //   this.color = {'backgound-color' : 'rgb(' + this.currentColor + ')'};
  //   // console.log('color is', this.color);
  //   // return this.color;
  // }
}
